import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guias',
  templateUrl: './guias.component.html',
  styleUrls: ['./guias.component.css']
})
export class GuiasComponent implements OnInit {

  popupVisible: boolean = false;
  popupVisibleImagen: boolean = false;
  constructor() { }

  ngOnInit() {
  }

  showModalAdd() {
    this.popupVisible = true;
  }
  showModalImage() {
    this.popupVisibleImagen = true;
  }

}

